module.exports = coreApis.utils.urls;